import { render, staticRenderFns } from "./dtPickComb.vue?vue&type=template&id=0316e1e8"
import script from "./dtPickComb.vue?vue&type=script&lang=js"
export * from "./dtPickComb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports